<template>
	<div class="app-top-bar pb-5 pb-lg-0 d-flex justify-center">
		<v-app-bar
			class="pr-3 pl-3 justify-space-between pb-2 px-md-12 px-lg-0"
			clipped-right
			:height="headerHeight"
			max-width="1440px"
		>
			<router-link :to="getLogoUrl">
				<v-toolbar-title class="left-side">
					<img :src="headerLogo" alt="Logo" class="logo" />
					<span class="title-text">{{appTitle}}</span>
				</v-toolbar-title>
			</router-link>

			<v-spacer></v-spacer>

			<v-spacer class="hidden-md-and-down"></v-spacer>
			<Menu
				:is-auth="isAuth"
				:opacity-routes="opacityRoutes"
				:profile-settings="profileSettings"
				:categories="categoriesList"
				:user-avatar="userProfileAvatar"
			/>
		</v-app-bar>
		<MobileMenu
			:display-menu="drawer"
			:is-auth="isAuth"
			:profile-settings="profileSettings"
			:categories="categoriesList"
			:user-avatar="userProfileAvatar"
		/>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import MainLogo from '@/assets/images/logo.png'
import profileIcon from '@/assets/images/profile-icon.svg'
import settingsIcon from '@/assets/images/settings-icon.svg'
import logoutIcon from '@/assets/images/logout-icon.svg'

import MobileMenu from '@/components/MobileMenu'
import Menu from '@/components/Menu'

export default {
	name: 'TopBar',
	components: {
		MobileMenu,
		Menu,
	},
	data() {
		return {
			MainLogo: MainLogo,
			selectedCategory: null,
			navOpacity: {
				left: false,
			},
			drawer: null,
			category: null,
			navOp: false,
			isActive: false,
			opacityRoutes: ['CreatePost', 'chat', 'Notifications', 'MapPage'],
			profileSettings: [
				{ id: 1, name: 'Profile', action: () => {}, path: '/profile-pre-view', icon: profileIcon },
				{ id: 2, name: 'Settings', action: () => {}, path: '/settings', icon: settingsIcon },
				{ id: 3, name: 'Logout', action: this.exit, icon: logoutIcon },
			],
		}
	},
	computed: {
		...mapGetters('category', ['isCategoryLoading', 'categories']),
		...mapGetters('auth', ['isAuthenticated', 'profile']),
		...mapGetters('settings', ['appCore', 'ci_cd']),
		categoriesList: function () {
			return this.categories
		},
		isAuth: function () {
			return this.isAuthenticated
		},
		userProfileAvatar: function () {
			return this.profile?.user_logo
		},
		headerHeight() {
			return this.$vuetify.breakpoint.mobile ? '64px' : '60px'
		},
		headerLogo() {
			if (this.ci_cd) {
				return this.ci_cd.app_icon
			}

			return MainLogo
		},
		appTitle() {
			if (this.ci_cd) {
				return this.ci_cd.device_name
			}

			return 'Clowder Web'
		},
		getLogoUrl() {
			if (this.appCore) {
				const { route = {name: 'events'} } = this.appCore.appMenuNormalized.baseMenuItems[0]
				return route;
			}

			return {name: 'events'};
		}
	},
	watch: {
		selectedCategory: {
			handler(val) {
				this.categoryId = val ? this.categories[val].id : null
				this.categoryHandler(this.categoryId)
			},
			deep: true,
		},
		$route() {
			this.navOpacity.left = this.opacityRoutes.includes(this.$route.name)
		},
	},
	methods: {
		...mapActions('category', ['fetchCategories', 'setCategory']),
		...mapActions('auth', ['logout']),
		exit() {
			this.logout()
		},
		categoryHandler(id) {
			if (this.$route.name !== 'Home') {
				this.$router.push({ name: 'Home' })
			}

			this.setCategory(id)

			this.$emit('nav-change', {
				category: id,
			})
		},
	}
}
</script>

<style lang="scss">
.logo {
	height: 24px;
	margin-right: 8px;
}

.left-side {
	display: flex;
	align-items: center;
	cursor: pointer;
}

.title-text {
	width: 112px;
	height: 20px;
	color: rgb(255, 255, 255);
	font-size: 16px;
	font-family: Montserrat, sans-serif;
	font-weight: 600;
	line-height: 20px;
}

.v-list-item--active::before {
	opacity: 0 !important;
}

.logo-opacity {
	transition: ease-in 0.2s;
	opacity: 0.5;
}

.app-top-bar {
	box-shadow: 0 4px 11px rgb(0 0 0 / 6%) !important;
	z-index: 1;
	background-color: var(--accent-color);

	a {
		text-decoration: none;
	}

	header {
		margin: 0 auto;
		box-shadow: none !important;
	}

	&__active-profile {
		color: #747474 !important;
		text-decoration: underline;
	}

	.map-icon {
		svg {
			stroke: #b9b9b9;
			fill: none;
		}
	}

	svg {
		fill: #b9b9b9;
	}

	.create-button-wrapper {
		display: flex;
		border: 2px solid #aaa;
		border-radius: 50%;
		padding: 10px;
		background-color: #fff !important;

		svg {
			fill: #aaa;
		}
	}

	&__navigation {
		&-active {
			opacity: 1;

			svg {
				fill: #db7842;
			}

			.create-button-wrapper {
				color: #fff !important;
				border: 2px solid #db7842;
				background-color: #db7842 !important;
				svg {
					fill: #fff;
				}
			}
		}

		&-active.map-icon {
			svg {
				stroke: #db7842;
				fill: none !important;
			}
		}
	}

	&__right-menu {
		display: flex;
		justify-content: flex-end;
		align-items: center;

		.theme--light.v-list-item:hover::before {
			opacity: 0;
		}

		.theme--light.v-btn:hover::before {
			opacity: 0;
		}

		.v-ripple__container {
			opacity: 0;
		}
	}

	&__categories {
		cursor: pointer;
		height: 100%;
		margin-right: 16%;
		text-transform: none !important;
		font: bolder 15px/1.2 'Montserrat' !important;
		text-decoration: none !important;
	}

	&__category {
		color: #fff !important;
		font: 600 13px/1.45 'Montserrat';
		margin-left: 15px;
		text-decoration: none;
		text-transform: none !important;
		background-color: inherit !important;
		border-left-width: 1px !important;
		height: 36px !important;
		min-width: 64px;
		padding: 0 16px !important;

		.v-btn__content {
			font-family: Montserrat, sans-serif;
			font-style: normal;
			font-weight: bold;
			font-size: 15px;
			line-height: 18px;
			letter-spacing: 0.225472px;
			text-transform: none !important;
			color: rgba(32, 34, 50, 1);
		}

		&:before {
			opacity: 0 !important;
		}
	}

	&__category-active {
		background-color: #db7842 !important;
		opacity: 1 !important;

		.v-btn--active {
			opacity: 0 !important;
		}

		.v-btn__content {
			color: #fff;
		}

		&:before {
			opacity: 0 !important;
		}
	}

	.v-toolbar {
		&__content {
			padding-bottom: 0;
			background-color: var(--accent-color);
		}
	}

	&__category:hover {
		.v-btn__content {
			color: #fff !important;
		}
		background: #db7842 !important;
		transition: color 0.2s, background-color 0.2s, border-color 0.2s;
	}

	&__category:hover::before {
		opacity: 0 !important;
	}

	&__login {
		color: #fff !important;
		height: 36px;
		font: 600 13px/1.45 'Montserrat';
		margin-left: 15px;
		text-decoration: none;
		text-transform: none !important;
	}

	&__map-icon {
		padding-left: 3px;
	}
	&__notification-icon {
		padding-right: 5px !important;
	}

	&__search {
		width: 50px;
		font: 600 13px/1.2 'Montserrat' !important;
		color: #b9b9b9;

		&-expanded {
			display: flex;
		}

		&-hidden {
			display: none;
		}

		&-input {
			width: 250px;
			padding: 0;
			border: 0;
			font: 600 13px/1.2 'Montserrat';
			white-space: pre;

			input::placeholder {
				color: #747474 !important;
				opacity: 1;
			}
		}

		&-input:focus {
			outline: none;
		}
	}

	&__search:focus {
		outline: none;
	}

	&__search-icon:focus::after {
		opacity: 0 !important;
	}

	&__search::placeholder {
		font: 600 13px/1.2 'Montserrat';
		color: #b9b9b9;
	}

	&__avatar-btn {
		padding-bottom: 3px !important;
		padding-right: 4px !important;
	}

	.theme--light.v-btn:focus::before {
		opacity: 0;
	}

	&__profile-avatar {
		padding-right: 2px;
		padding-top: 2px;

		.v-btn:before {
			opacity: 0 !important;
		}

		.v-ripple__container {
			opacity: 0 !important;
		}
	}

	&__profile-menu {
		margin-top: 2px;
		contain: initial !important;
		overflow: visible !important;
	}

	&__profile-card {
		border-radius: 4px !important;
		width: 190px !important;

		.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
			color: #747474 !important;
		}

		&-item {
			font-family: Montserrat, sans-serif;
			font-size: 16px;

			&:hover {
				text-decoration: underline;
			}
		}
	}

	@media screen and (min-width: 1320px) {
		.v-toolbar__content {
			max-width: 1284px;
			margin: 0 auto;
		}
	}

	@media screen and (min-width: 1400px) {
		.v-toolbar__content {
			max-width: 1400px;
			margin: 0 auto;
		}
	}

	.v-app-bar {
		background-color: var(--accent-color) !important;

		&__nav-icon .v-icon {
			font-size: 45px !important;
		}
	}
}
</style>
